
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PropertyDetailsTab } from "./PropertyDetailsTab";
import { PropertyImagesTab } from "./PropertyImagesTab";
import { PropertyStatusTab } from "./PropertyStatusTab";
import { PropertyVideoTab } from "./PropertyVideoTab";

interface EditPropertyTabsProps {
  activeTab: string;
  onTabChange: (value: string) => void;
  propertyData: any;
  propertyImages: any[];
  onImagesUpdated: () => void;
}

export const EditPropertyTabs = ({
  activeTab,
  onTabChange,
  propertyData,
  propertyImages,
  onImagesUpdated
}: EditPropertyTabsProps) => {
  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className="w-full">
      <TabsList className="grid w-full grid-cols-4">
        <TabsTrigger value="details">Property Details</TabsTrigger>
        <TabsTrigger value="images">Images</TabsTrigger>
        <TabsTrigger value="video">Video</TabsTrigger>
        <TabsTrigger value="status">Property Status</TabsTrigger>
      </TabsList>
      
      <TabsContent value="details" className="mt-4">
        <PropertyDetailsTab {...propertyData} />
      </TabsContent>

      <TabsContent value="images" className="mt-4">
        <PropertyImagesTab 
          propertyId={propertyData.id}
          currentImages={propertyImages}
          onImagesUpdated={onImagesUpdated}
        />
      </TabsContent>

      <TabsContent value="video" className="mt-4">
        <PropertyVideoTab 
          propertyId={propertyData.id}
          currentVideoUrl={propertyData.property.video_url}
          currentThumbnailUrl={propertyData.property.video_thumbnail_url}
          onVideoUpdated={onImagesUpdated}
        />
      </TabsContent>
      
      <TabsContent value="status" className="mt-4">
        <PropertyStatusTab {...propertyData} />
      </TabsContent>
    </Tabs>
  );
};
